import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormField from "./FormField";
import { setForm1Options } from "../../../../../services/slices/addformSlice";
import { isValue } from "../../../../../utils/constants/constants";
import CustomModal from "../../../../../components/common/modal/customModal";

const StepOne = ({ setActiveStep, initialData }) => {
    const dispatch = useDispatch()
    const yourAirlineOptions = useSelector(state => state?.userAirline?.userAirline);
    const brandOptions = useSelector(state => state?.source?.sourceDatas?.carrier);
    const metaOtaOptions = useSelector(state => state?.source?.sourceDatas?.source)
    const userDetails = useSelector(state => state?.userDetails?.userdetails)
    const [openModal, setOpenModal] = useState(false);
    const [modalContent, setModalContent] = useState(isValue?.emptyString);
    const [formData, setFormData] = useState(initialData);
    const { form1Options } = useSelector(state => state?.addShop);


    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            ...form1Options
        }));
    }, [form1Options]);

    useEffect(() => {
        if (!form1Options?.brands.length && !form1Options?.ota?.length && !form1Options?.meta?.length && !form1Options?.rateparity?.length && !form1Options?.yourAirline?.length) {
            const gdsValue = window?.location?.pathname?.includes("new") ? userDetails.isGds && userDetails?.isTravelportGds
                ? [430, 445]
                : userDetails?.isGds
                    ? [430]
                    : userDetails?.isTravelportGds
                        ? [445]
                        : [] : formData?.gds;

            setFormData(prevData => ({ ...prevData, gds: gdsValue }));

            dispatch(setForm1Options({ ...form1Options, ...formData, gds: gdsValue }));

        }
        // eslint-disable-next-line
    }, []);

    // Meta/OTA simultaneous-selection restriction disabled for now (was added alongside Deep Search)
    // // Dynamically find all OTA <-> MetaSource conflict pairs by normalized name
    // const conflictingPairs = React.useMemo(() => {
    //     if (!metaOtaOptions?.length) return [];
    //     const otas = metaOtaOptions.filter(dt => dt.sourceType === "OTA");
    //     const metas = metaOtaOptions.filter(dt => dt.sourceType === "Metasource");
    //
    //     const pairs = [];
    //     otas.forEach(ota => {
    //         const otaNorm = (ota.source || "").toLowerCase().replace(/ota|metasource|meta/gi, "").trim();
    //         const metaMatch = metas.find(m => {
    //             const metaNorm = (m.source || "").toLowerCase().replace(/ota|metasource|meta/gi, "").trim();
    //             return otaNorm && metaNorm && (otaNorm === metaNorm || (otaNorm.includes("google") && metaNorm.includes("google")));
    //         });
    //         if (metaMatch) {
    //             const displayName = otaNorm ? otaNorm.charAt(0).toUpperCase() + otaNorm.slice(1) : ota.source;
    //             pairs.push({
    //                 name: displayName || "Source",
    //                 otaCode: ota.code,
    //                 metaCode: metaMatch.code,
    //                 isGoogle: otaNorm.includes("google") || (metaMatch.source || "").toLowerCase().includes("google")
    //             });
    //         }
    //     });
    //     return pairs;
    // }, [metaOtaOptions]);
    //
    // const googleMetaCode = React.useMemo(() => {
    //     const googleMetaItem = metaOtaOptions?.find(dt => dt.sourceType === "Metasource" && dt.source?.toLowerCase().includes("google"));
    //     return googleMetaItem?.code || 20;
    // }, [metaOtaOptions]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => {
            let updatedData = { ...form1Options, ...prevData, [name]: value };

            // Handle the 'rateparity' condition (Meta/OTA conflict restriction removed, kept prior Google rate-parity linkage)
            if (name === "rateparity" && value.includes("Yes")) {
                const newMeta = [...(updatedData.meta || []), 20];
                updatedData = { ...updatedData, meta: newMeta };
            } else if (name === "rateparity" && value.length === 0) {
                updatedData = { ...updatedData, meta: (updatedData.meta || []).filter(data => data !== 20) };
            } else if (name === "meta" && value.includes(20)) {
                updatedData = { ...updatedData, rateparity: ["Yes"] };
            } else if (name === "meta" && !value.includes(20)) {
                updatedData = { ...updatedData, rateparity: [] };
            }

            dispatch(setForm1Options(updatedData));
            return updatedData;
        });
    };

    const handleClear = () => {
        setFormData(initialData);
    };

    const [fieldsConfig, setFieldsConfig] = useState([]);

    useEffect(() => {
        // Meta/OTA simultaneous-selection restriction disabled for now (was added alongside Deep Search)
        // const selectedOtaSet = new Set(formData.ota || []);
        // const selectedMetaSet = new Set(formData.meta || []);
        // const isRateParitySelected = (formData.rateparity || []).includes("Yes");

        const otaOptions = metaOtaOptions?.filter(dt => dt.sourceType === "OTA")?.map(data => {
            // const conflict = conflictingPairs.find(p => p.otaCode === data.code);
            // const isConflictDisabled = conflict && (selectedMetaSet.has(conflict.metaCode) || (conflict.isGoogle && isRateParitySelected));
            return {
                label: data?.source,
                value: data?.code,
                // disabled: isConflictDisabled,
                // disabledTooltip: isConflictDisabled ? `${data?.source} cannot be selected when its MetaSource counterpart is active.` : ""
            };
        }) || [];

        const metaOptions = metaOtaOptions?.filter(dt => dt.sourceType === "Metasource")?.map(data => {
            // const conflict = conflictingPairs.find(p => p.metaCode === data.code);
            // const isConflictDisabled = conflict && selectedOtaSet.has(conflict.otaCode);
            return {
                label: data?.source,
                value: data?.code,
                // disabled: isConflictDisabled,
                // disabledTooltip: isConflictDisabled ? `${data?.source} cannot be selected when its OTA counterpart is active.` : ""
            };
        }) || [];

        // const isGoogleOtaSelected = conflictingPairs.some(p => p.isGoogle && selectedOtaSet.has(p.otaCode));
        const rateParityOptions = [{
            label: "Add Rate Parity Data (Based On Google Flights)",
            value: "Yes",
            // disabled: isGoogleOtaSelected,
            // disabledTooltip: isGoogleOtaSelected ? "Rate Parity cannot be selected when Google OTA is active." : ""
        }];

        const baseConfig = [
            {
                id: "yourAirline",
                label: "Your Airline :",
                name: "yourAirline",
                type: "checkbox",
                value: initialData.yourAirline,
                options: yourAirlineOptions?.map(data => ({ label: data?.userAirline, value: data?.airlineCode })),
                optionLength: yourAirlineOptions?.map(data => ({ label: data?.userAirline, value: data?.airlineCode }))?.length,
                ClassNames: "checkbox-input",
            },
            // {
            //     id: "searchType",
            //     label: "Search Type :",
            //     name: "searchType",
            //     type: "searchType",
            //     ClassNames: "flex-radiobox",
            // },
            {
                id: "brands",
                label: "Pick Brands.com :",
                name: "brands",
                type: "checkbox",
                options: brandOptions?.map(data => ({ label: data?.source, value: data?.code })),
                optionLength: brandOptions?.map(data => ({ label: data?.source, value: data?.code })).length,
                ClassNames: "checkbox-input source-dropdown",
                searchable: true,
                searchPlaceholder: "Search Brands.com",
            },
            {
                id: "ota",
                label: "Pick OTAs :",
                name: "ota",
                type: "checkbox",
                options: otaOptions,
                optionLength: otaOptions.length,
                ClassNames: "checkbox-input source-dropdown",
                searchable: true,
                searchPlaceholder: "Search OTAs"
            },
            {
                id: "isAncillary",
                label: "Fares :",
                name: "isAncillary",
                type: "radio",
                options: [{ label: "Regular", value: "No" }, { label: "Ancillaries", value: "Yes" }],
                ClassNames: "flex-radiobox",
            },
            {
                id: "meta",
                label: "Pick MetaSources :",
                name: "meta",
                type: "checkbox",
                options: metaOptions,
                optionLength: metaOptions.length,
                ClassNames: "checkbox-input source-dropdown",
                searchable: true,
                searchPlaceholder: "Search MetaSources"
            },
            {
                id: "rateparity",
                label: " ",
                name: "rateparity",
                type: "checkbox",
                options: rateParityOptions,
                ClassNames: "checkbox-input rate-parity-label",
            }
        ];

        if (userDetails?.isGds || userDetails?.isTravelportGds) {
            baseConfig.splice(2, 0, {
                id: "gds",
                label: "Pick GDS:",
                name: "gds",
                type: "checkbox",
                options: metaOtaOptions?.filter(dt => dt.sourceType === "GDS")?.map(data => ({ label: data?.source, value: data?.code })),
                ClassNames: "checkbox-input source-dropdown",
                searchable: true,
                searchPlaceholder: "Search GDS"
            });
        }

        setFieldsConfig(baseConfig);
    }, [metaOtaOptions, brandOptions, yourAirlineOptions, userDetails, formData.ota, formData.meta, formData.rateparity]);


    // Update the `handleSearchable` function
    const handleSearchable = (e, fieldName) => {
        const searchString = e.target.value.toLowerCase();
        // Meta/OTA simultaneous-selection restriction disabled for now (was added alongside Deep Search)
        // const selectedOtaSet = new Set(formData.ota || []);
        // const selectedMetaSet = new Set(formData.meta || []);
        // const isRateParitySelected = (formData.rateparity || []).includes("Yes");

        const otaOpts = metaOtaOptions?.filter(dt => dt.sourceType === "OTA")?.map(data => {
            // const conflict = conflictingPairs.find(p => p.otaCode === data.code);
            // const isConflictDisabled = conflict && (selectedMetaSet.has(conflict.metaCode) || (conflict.isGoogle && isRateParitySelected));
            return {
                label: data?.source,
                value: data?.code,
                // disabled: isConflictDisabled,
                // disabledTooltip: isConflictDisabled ? `${data?.source} cannot be selected when its MetaSource counterpart is active.` : ""
            };
        }) || [];

        const metaOpts = metaOtaOptions?.filter(dt => dt.sourceType === "Metasource")?.map(data => {
            // const conflict = conflictingPairs.find(p => p.metaCode === data.code);
            // const isConflictDisabled = conflict && selectedOtaSet.has(conflict.otaCode);
            return {
                label: data?.source,
                value: data?.code,
                // disabled: isConflictDisabled,
                // disabledTooltip: isConflictDisabled ? `${data?.source} cannot be selected when its OTA counterpart is active.` : ""
            };
        }) || [];

        const optionsAvailable = fieldName === "gds" ? metaOtaOptions?.filter(dt => dt.sourceType === "GDS")?.map(data => ({ label: data?.source, value: data?.code })) :
            fieldName === "meta" ? metaOpts :
                fieldName === "ota" ? otaOpts :
                    fieldName === "brands" ? brandOptions?.map(data => ({ label: data?.source, value: data?.code })) : [];

        setFieldsConfig(prevFields =>
            prevFields.map(field => {
                if (field.name === fieldName) {
                    return {
                        ...field,
                        options: optionsAvailable?.filter(option =>
                            option.label.toLowerCase().includes(searchString)
                        )
                    };
                }
                return field;
            })
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { yourAirline, brands, ota, meta, gds } = formData
        if (yourAirline?.length || brands?.length || ota?.length || meta?.length || gds?.length) {
            setActiveStep(1)
        } else {
            setOpenModal(true);
            setModalContent("Please select Your Airline or atleast one of the Brands, GDS, OTAs or MetaSources.");
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <FormField
                    formData={formData}
                    handleChange={handleChange}
                    cancelOnClick={handleClear}
                    setFormData={setFormData}
                    handleSearchable={handleSearchable}
                    fieldsConfig={fieldsConfig} />
                <div className={"stepper-btn stepper-first-btn no-translate"}>
                    <button type="submit" className="secondary_button stepper-next-btn">Next - Choose Flight Attributes</button>
                </div>
            </form>
            <CustomModal
                open={openModal}
                handleClose={() => setOpenModal(!openModal)}
                lable={{ labelOne: "close", labelTwo: "ok" }}
                content={[{ header: "Warning" }, { modalContent: modalContent }]}
                handleClickOk={() => setOpenModal(false)}
            />
        </>
    );
};

export default StepOne;


